export enum UserRole
{
  VENDOR = 'vendor',
  DRIVER = 'delivery_partner',
  SUPER_ADMIN = 'super_admin',
}

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_ROLE: 'user_role',
  SUBSCRIPTION_ACTIVE: 'subscription_active',
} as const;
